const d3 = require('d3');
const { getCurrencySymbol, getFormattedAmount } = require('utilities/currencyHelper');
const { DATE_PICKER_CUSTOM_LOCALE } = require('constants/commonsComponents');
const es_ES = {
    'decimal': '.',
    'thousands': ',',
    'grouping': [3],
    'currency': ['$', ''],
    'dateTime': '%a %b %e %X %Y',
    'date': '%m/%d/%Y',
    'time': '%H:%M:%S',
    'periods': ['AM', 'PM'],
    'days': ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    'shortDays': ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
    'months': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    'shortMonths': ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
};
const en_US = {
    'decimal': '.',
    'thousands': ',',
    'grouping': [3],
    'currency': ['\$', ''],
    'dateTime': '%a %b %e %X %Y',
    'date': '%m/%d/%Y',
    'time': '%H:%M:%S',
    'periods': ['AM', 'PM'],
    'days': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    'shortDays': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    'months': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    'shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
};

const axisDateLabel = () => {
    let loc;

    if (DATE_PICKER_CUSTOM_LOCALE === 'es') {
        loc = d3.locale(es_ES);
    } else if (DATE_PICKER_CUSTOM_LOCALE === 'en') {
        loc = d3.locale(en_US);
    } else {
        loc = d3.locale(en_US);
    }

    return loc.timeFormat('%b');
};

const yAxisFormatLabel = (d, currency) => {

    // @hardcoded some warrants come with an empty string as currencyCode V
    const moneyObj = { amount: d, currency: currency.trim().length ? currency.trim() : 'EUR'};
    const curr = getCurrencySymbol(moneyObj);
    const amount = getFormattedAmount(moneyObj);

    return amount + ' ' + curr;
};

const transformToISO = (apiDate) => {
    const splittedDate = apiDate.split('/');
    return `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
};

const dateTicks = (min, max) => {
    const monthsDiff = max.month() - min.month();
    /**
     * TODO fix here if we want to set manual the ticks with .tickValues()
     * 2 is for the extremes
     */

    return monthsDiff + 2;
};

module.exports = {
    axisDateLabel,
    yAxisFormatLabel,
    transformToISO,
    dateTicks
};
